export default __webpack_public_path__ + "static/media/slide1.eaae1b92.jpg";